import fetch from '@/utils/fetch';
import {newcard} from '@/utils/fetch';

//条件查询卡列表(分页)
export function listCardByModelAndPage(args) {
  let params = new URLSearchParams();
  params.append('cardNo', args.cardNo);
  params.append('pageNo', args.pageNo);
  params.append('pageSize', args.pageSize);
  return newcard({
    url: 'structure/campusCardPool/listCardByModelAndPage',
    method: 'get',
    params
  });
}

//新增卡(批量)
export function insertBatchCampusCard(cardNoList) {
  return newcard({
    headers: {
      'content-type': 'application/json'
    },
    url: 'structure/campusCardPool/insertBatchCampusCard',
    method: 'POST',
    data: JSON.stringify(cardNoList)
  });
}

//根据卡号删除卡(物理删除)
export function deleteCardByCardNo(cardNo) {
  let params = new URLSearchParams();
  params.append('cardNo', cardNo);
  return newcard({
    url: 'structure/campusCardPool/deleteCardByCardNo',
    method: 'post',
    data: params
  });
}

//重置卡
export function resetCard(sid) {
  let params = new URLSearchParams();
  params.append('sid', sid);
  return newcard({
    url: 'structure/campusCard/resetCard',
    method: 'post',
    data: params
  });
}

//根据卡号查询所有绑定过和已删除的校园卡信息
export function getAllCardBySid(sid) {
  let params = new URLSearchParams();
  params.append('sid', sid);
  return newcard({
    url: 'structure/campusCard/getAllCardBySid',
    method: 'get',
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/campusCrd.js